/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { Panel } from 'react-bootstrap';
import Refresher from 'loracoms/Refresher';
import CollapseToggle from 'loracoms/CollapseToggle';
import IntlMsg from 'lorautils/intl/IntlMsg';
import LineChart from 'loracoms/LineChart';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  series: React.PropTypes.object.isRequired,
  reloading: React.PropTypes.bool.isRequired,
  onReload: React.PropTypes.func.isRequired,
};

class DeviceSNRTrend extends React.Component {

  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.statview');
    this.state = {
      series: props.series,
      reloading: props.reloading,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { series, reloading } = nextProps;
    if (series !== this.props.series) {
      this.setState({ series });
    }
    if (reloading !== this.props.reloading) {
      this.setState({ reloading });
    }
  }

  render() {
    const { onReload } = this.props;
    const {
      series,
      reloading,
      expanded = true,
      resize = 0,
    } = this.state;

    const header = (
      <div>
        SNR
        <ul className="icontools">
          <li>
            <Refresher
              onReload={onReload}
              reloading={reloading}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={expanded}
              onChange={(v) => { this.setState({ expanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={expanded}
        onEntered={() => { this.setState({ resize: Math.random() }); }}
      >
        <LineChart
          yAxis={[
            {
              name: 'SNR',
              splitNumber: 5,
            },
          ]}
          xAxis={{
            axisTick: { alignWithLabel: true },
            boundaryGap: true,
          }}
          series={[series.snr]}
          categories={series.categories}
          dataZoom={[{
            type: 'slider',
            fillerColor: 'rgba(228, 241, 254, 0.4)',
            dataBackground: {
              lineStyle: { width: 0 },
              areaStyle: { color: 'rgba(107, 185, 240, 0.8)' },
            },
          }]}
          tooltip={{
            formatter: (params) => {
              const dataLines = params.map(p =>
                `<span style="display: inline-block; background: ${p.color}; width: 9px; height: 9px; border-radius: 100%;"></span> ${p.seriesName} : ${_.isNil(p.value) ? '-' : Number(p.value).toFixed(1)}`).join('<br />');
              return `${params[0].name}<br />${dataLines}`;
            },
          }}
          grid={{
            left: 60,
            top: 30,
            right: 30,
            bottom: 60,
          }}
          colorShift={2}
          resize={resize}
        />
      </Panel>
    );
  }
}

DeviceSNRTrend.propTypes = propTypes;

export default injectIntl(DeviceSNRTrend);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceSNRTrend/index.jsx